import axios from "@util/axios";
import moment from "moment";
import { ProfileService } from "@services";


export default {
	computed: {
		userCompany() {
			return ProfileService.user.company;
		},
	},
	methods: {
		async checkParameterDatas(
			columns = [],
			parameters = [],
			flags = [],
			role = null,
			roleValue = null
		) {
			const response = await axios({
				url: `/get/parameters/`,
				method: "POST",
				data: {
					columns_to_show: columns,
					flag: flags,
					parameters: parameters,
					role: role || this.companyRole,
					role_value: roleValue || this.companyRoleValue,
				},
			});

			return response;
		},
		async checkParameterDatasByColumn(
			type,
			column,
			role = null,
			roleValue = null,
			args = {}
		) {
			const params = [];
			const flags = [];

			if ("report-date" === type) {
				const startMonth = moment().startOf("month");
				const endMonth = moment().endOf("month");

				if (args.period && "prev-month" === args.period) {
					startMonth.subtract(1, "month");
					endMonth.subtract(1, "month");
				}

				params.push({
					name: "Reporting_Period_End_Date",
					type: "Range",
					value: `${startMonth.format(
						"MM-DD-YYYY"
					)},${endMonth.format("MM-DD-YYYY")}`,
				});
			} else if ("flag" === type) {
				if (args.flag) {
					if ("critical" === args.flag) {
						flags.push({
							name: "Critical_Error_Flag",
							value: 1,
						});
					} else if ("non-critical" === args.flag) {
						flags.push({
							name: "Critical_Error_Flag",
							value: 1,
						});
						flags.push({
							name: "Non_Critical_Flag",
							value: 1,
						});
					} else if ("no-errors" === args.flag) {
						flags.push({
							name: "Critical_Error_Flag",
							value: 0,
						});
						flags.push({
							name: "Non_Critical_Flag",
							value: 0,
						});
					}
				}
			}

			return await this.checkParameterDatas(
				[column],
				params,
				flags,
				role,
				roleValue
			);
		},
	},
};
